import React, { useState, useEffect } from 'react';
import styles from '../styles/Users.module.css';

const initialForm = {
  id: '',
  name: '',
  phone: '',
  email: '',
  role: 'Viewer',
  status: 'Active',
};

const UserForm = ({ user, onClose, onSave }) => {
  const [form, setForm] = useState(initialForm);

  useEffect(() => {
    if (user) setForm(user);
    else setForm(initialForm);
  }, [user]);

  const handleSubmit = e => {
    e.preventDefault();
    // Validate required fields
    if (!form.name || !form.email || !form.phone || !form.role || !form.status) {
      alert('Please fill all required fields.');
      return;
    }
    let data = { ...form };
    if (!user && !form.id) {
      // If adding and ID is empty, generate a dummy ID
      data.id = Math.floor(Math.random() * 100000).toString();
    }
    onSave(data);
  };

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <h3 className={styles.formTitle}>{user ? 'Edit User' : 'Add User'}</h3>
        <form onSubmit={handleSubmit}>
          <div className={styles.formGroup}>
            <label>ID</label>
            <input value={form.id} onChange={e => setForm({ ...form, id: e.target.value })} required />
          </div>
          <div className={styles.formGroup}>
            <label>Name</label>
            <input value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} required />
          </div>
          <div className={styles.formGroup}>
            <label>Phone</label>
            <input value={form.phone} onChange={e => setForm({ ...form, phone: e.target.value })} required />
          </div>
          <div className={styles.formGroup}>
            <label>Email</label>
            <input type="email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} required />
          </div>
          <div className={styles.formGroup}>
            <label>Role</label>
            <select value={form.role} onChange={e => setForm({ ...form, role: e.target.value })}>
              <option value="Admin">Admin</option>
              <option value="Editor">Editor</option>
              <option value="Viewer">Viewer</option>
            </select>
          </div>
          <div className={styles.formGroup}>
            <label>Status</label>
            <select value={form.status} onChange={e => setForm({ ...form, status: e.target.value })}>
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
            </select>
          </div>
          <div className={styles.formActions}>
            <button type="submit" className={styles.addButton}>{user ? 'Update' : 'Add'}</button>
            <button type="button" className={styles.cancelButton} onClick={onClose}>Cancel</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UserForm;

